import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Module from "../../../../layout/Module";
import { useParams } from "react-router-dom";
import FilterButtonDevelopmentalRubric from "../Filter/Filter";
import { getDevelopmentalRubricsGantt } from "../../../../../services/developmental-rubrics/developmental-rubrics.service";
import GanttChart from "../../../../commom/AnaCharts/Gantt";
import Skeleton from '@mui/material/Skeleton';
import { Paper, Typography } from "@mui/material";
import { updateFilter } from "../../../../../store/actions/filter.actions";
import isEmpty from "lodash/isEmpty";
import ChildCard from "../../../../card/ChildCard";

const Gantt = () => {
  const { curriculumId, studentId } = useParams();
  const currentDate = useSelector((state) => state?.date?.date || new Date());
  const timezone = useSelector((state) => state?.tenant?.timezone || 'UTC');
  const state = useSelector((state) => state?.filter?.gantt);
  const termActive = useSelector((state) => state?.tenant?.termActive);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [elementName, setElementName] = useState('');
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {});

  useEffect(() => {
    if (currentCurriculum?.elementsStructure) {
      const elementsStructure = currentCurriculum.elementsStructure?.children[0];
      if (elementsStructure) {
        setElementName(elementsStructure.name || 'Discipline');
      }
    }
  }, [currentCurriculum]);
  useEffect(() => {
    const filter = {
      startDate: currentDate,
      endDate: currentDate
    }
    if (!isEmpty(termActive)) {
      filter.startDate = termActive.startDate;
      filter.endDate = termActive.endDate;
    }
    dispatch(updateFilter('gantt', { ...filter, ...state.filter }));
  }, [termActive, currentDate]);

  const onLoad = useCallback(async () => {
    if (curriculumId) {
      const filter = state.filter || {};
      if (filter.startDate && filter.endDate) {
        try {
          setLoading(true);
          const filterData = {
            name: filter.name,
            yearLevel: filter.yearLevel,
            startDate: filter.startDate,
            endDate: filter.endDate,
            curriculumElements: filter.curriculumElements,
            subjectId: filter.subjectId,
            isLinked: filter.isLinked,
            isActived: filter.isActived,
            studentId
          };
          const response = await getDevelopmentalRubricsGantt(
            curriculumId,
            filterData
          );
          if (!response?.data && response?.error) {
            setError(response.error.message || "An error ocurred");
          } else {
            setData(response?.data || []);
          }
        } catch (error) {
          const message = handlerErrorV2(error);
          setError(message);
        } finally {
          setLoading(false);
        }
      }
    }
  }, [curriculumId, state.filter]);

  useEffect(() => {
    onLoad();
  }, [onLoad]);

  const GanttMemo = useMemo(
    () => (
      data.length === 0 ? (
        <div className="w-full h-full flex items-center justify-center">
          <Paper className="p-4">
            <Typography className="text-muted-foreground opacity-50">The chart has no data!</Typography>
          </Paper>
        </div>
      ) : 
      <GanttChart  elementName={elementName} chartID={`gantt-${curriculumId}`} timeZone={timezone} dataSet={{ datasets: data }} />
    ),
    [data, timezone]
  );

  return <>
    <Module.BodyHeader className="border-b border-b-2 border-primary justify-start">
      <ChildCard />
      <FilterButtonDevelopmentalRubric type="gantt" />
    </Module.BodyHeader>
    <Module.BodyContainer>
      {loading ? (<Skeleton variant="rectangular" height='100%' />) : GanttMemo}
    </Module.BodyContainer>
  </>;
};

export default Gantt;
